import React from 'react';

import { connect } from 'react-redux';

import commonStyle from 'commonStyle';

import TextCell from './'


const mapStateToProps = (state, ownProps) => {
    const value = {}

    const { selections = new Set([]) } = state;

    if (selections.has(ownProps.id)) {
        value.isSelected = true;
    } else {
        value.isSelected = false;
    }

    return Object.assign({}, ownProps, value);
};

function TextCellController(props) {
    const {
        name,
        isSelected,
        textClassName
    } = props;

    return (
        <TextCell
            name={name}
            isSelected={isSelected}
            selectedBackgroundColor={commonStyle.dimPrimary(0.1)}
            textClassName={textClassName}
        />
    )
}

export default connect(mapStateToProps)(TextCellController);